import * as actionType from '../actionTypes';

const initialState = {
    loader: false
}
const loader = (state = initialState, action) => {
    switch (action.type) {
        case actionType.LOADER_TRUE:
            return {
                loader: true
            };
        case actionType.LOADER_FALSE:
            return {
                loader: false
            }
        default:
            return state
    }
}
export default loader;